import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { forwardRef } from 'react';
import { merge } from 'lodash-es';
import { useIsInBottomSheet } from '../BottomSheet';
import { useDevice } from '../Device';
import { useOverlayContext } from '../OverlayContext';
import { BaseTextField } from '../TextField/BaseTextField/BaseTextField';
import { useTextFieldMobileMode } from '../TextField/TextFieldMobileModeContext';
import { MobileSelect, SelectOptionsBottomSheet } from './MobileSelect';
export const Select = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { enableMobileMode } = props, restProps = _object_without_properties(props, [
        "enableMobileMode"
    ]);
    const { isMobileDevice } = useDevice();
    const isInBottomSheet = useIsInBottomSheet();
    const { pushBottomSheetPage } = useOverlayContext();
    const contextMobileMode = useTextFieldMobileMode();
    const resolvedMobileMode = enableMobileMode !== null && enableMobileMode !== void 0 ? enableMobileMode : contextMobileMode;
    if (isInBottomSheet) {
        return /*#__PURE__*/ _jsx(BaseTextField, _object_spread_props(_object_spread({}, restProps), {
            ref: ref,
            select: true,
            SelectProps: merge(restProps.SelectProps, {
                open: false,
                onOpen: ()=>{
                    pushBottomSheetPage({
                        content: /*#__PURE__*/ _jsx(SelectOptionsBottomSheet, _object_spread({
                            saveOnSelect: true
                        }, restProps))
                    });
                }
            })
        }));
    } else if (resolvedMobileMode && isMobileDevice) {
        return /*#__PURE__*/ _jsx(MobileSelect, _object_spread_props(_object_spread({}, restProps), {
            ref: ref
        }));
    } else {
        return /*#__PURE__*/ _jsx(BaseTextField, _object_spread_props(_object_spread({}, restProps), {
            ref: ref,
            select: true
        }));
    }
});
